import React from "react";
import BaseComponent from "../../baseComponent.js";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import InternalEvent from "../../../core/constants/internalEvent.js";
import ReactDOM from "react-dom";
import WidgetService from "../../../core/services/widgetService.js";
import DashboardService from "../../../core/services/dashboardService.js";
import UniqueIdGenerator from "../../../core/utils/uniqueIdGenerator.js";

import AddWidgetSearch from "./search/addWidgetSearch.jsx";
import WidgetType from "../../../core/constants/widgetType.js";
import Title from "./title.jsx";
import Legends from "./legends/legends.jsx";
import TableLegend from "./legends/tableLegend.jsx";
import AppConfig from "../../../config/config.js";
import TimeSeriesWidget from "./widgets/timeSeries.jsx";
import PieChartWidget from "./widgets/pie.jsx";
import TextualWidget from "./widgets/textual.jsx";
import GaugeWidget from "./widgets/gauge.jsx";
import TableWidget from "./widgets/table.jsx";
import TreeMap from "./widgets/treeMap.jsx";
import Map from "./widgets/map.jsx"
import Spreadsheet from "./widgets/spreadsheet.jsx"
import TechnicalAnalysis from "./widgets/technialAnalysis.jsx";
import TimeSeriesConfig from "./legend-config/timeSeriesConfig.jsx";
import PieConfig from "./legend-config/pieConfig.jsx";
import TextualConfig from "./legend-config/textualConfig.jsx";
import GaugeConfig from "./legend-config/gagueConfig.jsx";
import TreeMapConfig from "./legend-config/treeMapConfig.jsx";
import TechnicalAnalysisConfig from "./legend-config/technicalAnalysisConfig.jsx";
import SideNav from "../../common/sidenav/sidenav.jsx";
import TableFieldList from "./widgets/tableFieldList.jsx";
import CheckBox from "../../../components/common/check-box/checkBox.jsx"
import styles from "./add-widget.scss";

import DatasetDetail from "./../../data-bank/dataset-detail/datasetDetail.jsx";
import DatasetService from "../../../core/services/datasetService.js";
import Bullet from "./widgets/bullet.jsx";
import CopyToDashboard from "../../data-bank/dataset-detail/content/copyToDashboard.jsx";
import FieldList from "./widgets/fieldList.jsx";
import RankingWidget from "../widgets/ranking/rankingWidget.jsx";
import TradingViewWidget from "../widgets/trading-view/tradingViewWidget.jsx";
import {getDefaultWidgetLegend, getDefaultPreviewWidgetLegend} from "./defaultLegend";

import TimeSeriesCongifs from "./timeseriesConfigs.jsx";

const ADD_WIDGET_TYPE = {
  ADD: "ADD",
  EDIT: "EDIT",
  COPY: "COPY"
};

const defaultResolutions = {
  tick: true,
  '1 second': true, '5 seconds': true, '15 seconds': true, '30 seconds': true,
  '1 minute': true, '5 minutes': true, '15 minutes': true, '30 minutes': true,
  '1 hour': true, '1 day': true, '1 week': true, '1 month': true, '1 year': true
};


var timer;

export default class AddWidget extends BaseComponent {
  constructor(props, context) {
    super(props);
    this.router = context.router;
    this.state = {
      title: "",
      legends: [],
      currentLegend: null,
      showLegends: false,
      // preview
      dataset: this.props.dataset,
      dataProfile: this.props.dataProfile,

      timeSeriesConfigs: {
        splitLeftRight: false,
        centerZeroLine: false,
        autoAdjustWindowSize: false,
        resolutions: defaultResolutions
      }

    };
    this.widgetType = WidgetService.getAddWidgetType() || WidgetType.TIME_SERIES;
    this.widgetId = UniqueIdGenerator.id();
    this.widget = null;
    this.addWidgetType = ADD_WIDGET_TYPE.ADD;
    this.isEditMode = false;
    this.timer = null;
  }

  componentDidMount() {
    const widgetId = this.getWidgetIdFromPath();

    if (this.props.isPreviewWidget) {
      this.loadDatasetWidget();
      this.subscribe(InternalEvent.Subscription.WIDGET_TYPE_CHANGED, this.handleWidgetTypeChange);
      this.subscribe(InternalEvent.Subscription.CHART_RESET, () => {
        this.updateWidget(this.state.legends.slice());
      });
      this.subscribe(InternalEvent.Subscription.TEXTUAL_WIDGET_UPDATED, this.createOrUpdateDatasetWidget);
      this.subscribe(InternalEvent.Dashboard.UPDATE_DASHBOARD_STATE, this.createOrUpdateDatasetWidget);
    } else {
      if (widgetId != null) {
        this.loadWidgetForEdit(widgetId);
      } else {
        if (this.widgetType === WidgetType.GAUGE ||
          this.widgetType === WidgetType.TEXTUAL) {
          this.addLegend({name: ""});
        }

        if (this.widgetType === WidgetType.SPREADSHEET) {
          this.addLegend();
        }
      }
      $(this.refs.container).fadeTo(500, 1);
    }
  }


  getDefaultLegend(payload) {
    payload.newLegendId = this.nextLegendId();
    payload.newLegendColor = this.getUnUsedLegendColor();
    return getDefaultWidgetLegend(this.widgetType, payload);
  }

  getDefaultLegendForPreviewWidget(widgetType) {
    return getDefaultPreviewWidgetLegend(widgetType, this.props);
  }

  /**
   * A event handler for widget type change in preview widget
   * @param widgetType
   */
  handleWidgetTypeChange(widgetType) {
    this.widgetType = widgetType;
    let legendsCopy = [this.getDefaultLegendForPreviewWidget(this.widgetType)];

    if (this.widgetType === WidgetType.TIME_SERIES) {
      this.setState({
        legends: legendsCopy,
        currentLegend: null
      });
    } else {
      this.setState({
        legends: legendsCopy,
        currentLegend: legendsCopy[0]
      });
    }

    this.updateWidget(legendsCopy);
    this.createOrUpdateDatasetWidget(legendsCopy);
  }

  getWidgetIdFromPath() {
    let index = location.pathname.indexOf("editWidget");
    if (index === -1) {
      index = location.pathname.indexOf("copyWidget");
      if (index > -1) {
        this.addWidgetType = ADD_WIDGET_TYPE.COPY;
      }
    } else {
      this.addWidgetType = ADD_WIDGET_TYPE.EDIT;
    }
    if (this.addWidgetType !== ADD_WIDGET_TYPE.ADD) {
      let widgetIdStartIndex = index + 11;
      return location.pathname.substring(widgetIdStartIndex, widgetIdStartIndex + 36);
    }
    return null;
  }

  // preview widget in data bank
  loadDatasetWidget() {
    if (this.props.widgetData) {
      let currentLegend = null;
      this.datasetWidget = this.props.widgetData;
      this.widgetType = this.datasetWidget.widgetState.type || this.datasetWidget.widgetState.widgetType;

      if (this.datasetWidget.widgetState.legends.length === 0) {
        this.datasetWidget.widgetState.legends = [this.getDefaultLegendForPreviewWidget(this.widgetType)];
      }

      if (this.widgetType === WidgetType.GAUGE ||
        this.widgetType === WidgetType.TEXTUAL ||
        this.widgetType === WidgetType.TABLE) {
        currentLegend = this.datasetWidget.widgetState.legends[0];
      }

      this.setState({
        legends: this.datasetWidget.widgetState.legends,
        currentLegend: currentLegend
      });
      this.updateWidget(this.datasetWidget.widgetState.legends, this.datasetWidget.widgetState.metaData);
      this.hasDefaultWidget = false;
    } else {
      let defaultLegends = [this.getDefaultLegendForPreviewWidget(WidgetType.TIME_SERIES)];
      this.setState({
        legends: defaultLegends
      });
      this.updateWidget(defaultLegends);
    }
  }

  // edit widget in dashboard
  loadWidgetForEdit(widgetId) {
    let currentDashboardId = localStorage.getItem("lastOpenedDashboard");
    DashboardService.findDashboardById(currentDashboardId)
      .then(dashboard => {
        for (let i = 0; i < dashboard.state.dashboardState.length; i++) {
          let widgetModel = dashboard.state.dashboardState[i].widgetModel;
          const {id, type, legends, title, autoAdjustWindowSize, centerZeroLine, splitLeftRight, metaData} = widgetModel;
          if (id === widgetId) {
            this.widgetId = widgetId;
            this.widgetType = type;

            let legendsCopy = JSON.parse(JSON.stringify(legends));
            let currentLegend = null;

            if (this.widgetType === WidgetType.GAUGE ||
              this.widgetType === WidgetType.TEXTUAL ||
              this.widgetType === WidgetType.TABLE) {
              currentLegend = legendsCopy[0];
            }


            this.setState({
              title: this.widgetType === ADD_WIDGET_TYPE.COPY ? "" : title,
              legends: legendsCopy,
              currentLegend: currentLegend,
              timeSeriesConfigs: {
                autoAdjustWindowSize,
                centerZeroLine,
                splitLeftRight,
                resolutions: metaData.resolutionList || defaultResolutions
              },
              showLegends: metaData.showLegends || false,
              widget: widgetModel
            }, () => {
              this.updateWidget(legendsCopy, metaData);
            });
            this.isEditMode = true;
            break;
          }
        }
      });
  }

  componentWillUnmount() {
    this.unsubscribeAll();
    this.removeWidget();
  }

  handleTitleChange(newTitle) {
    this.setState({
      title: newTitle
    });
  }

  handleAutoAdjustChange(value) {
    this.setState({
      autoAdjustWindowSize: value
    });
  }

  handleCenterZeroLineChange(value) {
    this.setState({
      centerZeroLine: value
    });
    this.updateWidget(this.state.legends, null, value, null);
  }

  handleSplitLeftRightChange(value) {
    this.setState({
      splitLeftRight: value
    });
    this.updateWidget(this.state.legends, null, null, value);
  }


  handleUpdateExpression(legend, key, expression, mappings) {
    let _this = this;


    if (expression.indexOf("DataSource") > -1) {
      legend.DataSource = expression;
    } else {
      legend.DataSource = null;
    }

    legend.expressions[key] = expression;
    legend.mappings = mappings;

    // extract server-side function mappings
    if (mappings.hasOwnProperty("serverSideFunction")) {
      legend.serverSideFunction = mappings.serverSideFunction;
      legend.serverSideFunctionExpression = mappings.serverSideFunctionExpression;
    }
    removeObsoleteMappings(legend.expressions, legend.mappings);
    let legendsCopy = this.state.legends.slice();

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(function () {
      _this.updateWidget(legendsCopy);
    }, 800);

    function removeObsoleteMappings(expressions, mappings) {
      let mappingKeys = Object.keys(mappings);
      for (let key in expressions) {
        let parsed = expressions[key].split(AppConfig.EXPRESSION_REGEX);
        for (let i = 0; i < parsed.length; i++) {
          let keyIndex = mappingKeys.indexOf(parsed[i].trim());
          if (keyIndex > -1) {
            mappingKeys.splice(keyIndex, 1);
          }
        }
      }

      for (let i = 0; i < mappingKeys.length; i++) {
        delete mappings[mappingKeys[i]];
      }
    }
  }

  handleChangeCurrentLegend(element, legend) {
    let legendToChange = legend;

    if (this.state.currentLegend && legend.id === this.state.currentLegend.id) {
      legendToChange = null;
    }

    this.setState({
      currentLegend: legendToChange
    });
  }

  closeLegendConfig() {
    this.setState({
      currentLegend: null
    });
  }

  handleRemoveCurrentLegend(legend) {
    let legendsCopy = this.state.legends.slice();
    let groupId = legend.parameters.groupId;
    let index = legendsCopy.length;
    while (index--) {
      if (legendsCopy[index].id === legend.id) {
        legendsCopy.splice(index, 1);
      } else if (groupId) {
        if (legendsCopy[index].parameters.groupId === groupId) {
          legendsCopy.splice(index, 1);
        }
      }
    }

    this.setState({
      legends: legendsCopy,
      currentLegend: null
    });

    this.updateWidget(legendsCopy);

    if (this.props.isPreviewWidget) {
      this.createOrUpdateDatasetWidget(legendsCopy);
    }
  }

  onConfirmClick() {
    const {autoAdjustWindowSize, centerZeroLine, splitLeftRight, resolutions} = this.state.timeSeriesConfigs;
    let widget = WidgetService.getWidget(this.widgetId);
    widget.title = this.state.title;
    widget.autoAdjustWindowSize = autoAdjustWindowSize;
    widget.centerZeroLine = centerZeroLine;
    widget.splitLeftRight = splitLeftRight;
    widget.metaData.resolutionList = resolutions;

    if (location.pathname.indexOf("copyWidget") > -1) {
      widget.id = UniqueIdGenerator.id();
    }
    if (widget) {
      this.publish(InternalEvent.App.SHOW_PRELOADER);
      DashboardService.addOrUpdateWidgetToCurrentDashboard(widget)
        .then(() => {
          WidgetService.removeWidget(this.widgetId);
          this.router.replace("/dashboard");
        });
    } else {
      WidgetService.removeWidget(this.widgetId);
      this.router.replace("/dashboard");
    }
  }

  onCancelClick() {
    let widget = WidgetService.getWidget(this.widgetId);
    this.publish(InternalEvent.App.SHOW_PRELOADER);
    if (widget) {
      ReactDOM.unmountComponentAtNode(this.refs.chartContainer);
      WidgetService.removeWidget(this.widgetId);
      this.context.router.replace("/dashboard");
    } else {
      this.context.router.replace("/dashboard");
    }
  }

  getUnUsedLegendColor(legends = this.state.legends) {
    let index = 0;
    for (let i = 0; i < AppConfig.DEFAULT_LEGEND_COLORS.length; i++) {
      let isUsed = false;
      for (let j = 0; j < legends.length; j++) {
        if (AppConfig.DEFAULT_LEGEND_COLORS[i] === legends[j].parameters.legendColor) {
          isUsed = true;
          break;
        }
      }
      if (!isUsed) {
        index = i;
        break;
      }
    }
    return AppConfig.DEFAULT_LEGEND_COLORS[index];
  }

  removeWidget() {
    if (this.widget) {
      ReactDOM.unmountComponentAtNode(this.refs.chartContainer);
      WidgetService.removeWidget(this.widgetId);
      this.widget = null;
    }
  }

  updateWidget(legends, metaData = {}) {
    const widget = WidgetService.getWidget(this.widgetId);
    if (widget) {
      metaData = widget.metaData;
    }
    this.removeWidget();
    let chartUIComponent;
    let componentType;
    let componentId = UniqueIdGenerator.id();
    let components = {};
    const timeSeriesConfigs = this.state.timeSeriesConfigs;

    if (legends.length > 0) {
      this.widget = WidgetService.createRealtimeWidget({
        widgetId: this.widgetId,
        mode: "ADD",
        title: this.state.title,
        type: this.widgetType,
        legends: legends,
        metaData: metaData,
        autoAdjustWindowSize: timeSeriesConfigs.autoAdjustWindowSize,
        centerZeroLine: timeSeriesConfigs.centerZeroLine,
        splitLeftRight: timeSeriesConfigs.splitLeftRight
      });

      switch (this.widgetType) {
        case WidgetType.TIME_SERIES_VERTICAL:
        case WidgetType.TIME_SERIES: {
          chartUIComponent = TimeSeriesWidget;
          break;
        }
        case WidgetType.PIE_CHART: {
          chartUIComponent = PieChartWidget;
          break;
        }
        case WidgetType.TEXTUAL: {
          chartUIComponent = TextualWidget;
          break;
        }
        case WidgetType.GAUGE: {
          chartUIComponent = GaugeWidget;
          break;
        }
        case WidgetType.TABLE: {
          chartUIComponent = TableWidget;
          break;
        }
        case WidgetType.TREE_MAP: {
          chartUIComponent = TreeMap;
          break;
        }
        case WidgetType.TECHNICAL_ANALYSIS_CHART: {
          chartUIComponent = TechnicalAnalysis;
          break;
        }
        case WidgetType.MAP: {
          chartUIComponent = Map;
          break;
        }
        case WidgetType.SPREADSHEET: {
          chartUIComponent = Spreadsheet;
          break;
        }
        case WidgetType.BULLET_VERTICAL: {
          chartUIComponent = Bullet;
          break;
        }
        case WidgetType.RANK_WIDGET: {
          chartUIComponent = RankingWidget;
          break;
        }
        case WidgetType.TRADING_VIEW: {
          chartUIComponent = TradingViewWidget;
          break;
        }
      }

      components[componentId] = {
        controller: {
          id: componentId,
          widgetId: this.widgetId,
          type: componentType
        }
      };

      ReactDOM.render(React.createElement(
        chartUIComponent,
        {
          widget: this.widget,
          model: this.widget,
          components: components,
          isEditMode: this.isEditMode,
          openSideNav: this.openSideNav,
          isAddWidget: true,
          isPreviewWidget: this.props.isPreviewWidget,
          metaData: metaData,
          legends: this.state.legends,
          changeCurrentLegend: this.handleChangeCurrentLegend,
          dataset: this.props.dataset,
          dataProfile: this.props.dataProfile
        }
      ), this.refs.chartContainer);
    }

    this.publish(InternalEvent.Dashboard.ADD_WIDGET_UPDATED);
  }


  getSecondaryLegend(legendsCopy) {
    let legends = legendsCopy || this.state.legends;
    for (let i = 0; i < legends.length; i++) {
      if (legends[i].id !== this.state.currentLegend.id &&
        legends[i].parameters.groupId === this.state.currentLegend.parameters.groupId) {
        return legends[i];
      }
    }

    return null;
  }

  /**
   * Chart type change event handler for time-series widget.
   * @param chartType
   */
  handleChartTypeChange(chartType) {
    let _this = this;
    let currentLegend = this.state.currentLegend;
    let legendsCopy = this.state.legends.slice();
    let previousChartType = this.state.currentLegend.parameters.chartType;
    currentLegend.parameters.chartType = chartType;

    // remove all expressions except y
    delete currentLegend.expressions.size;
    delete currentLegend.expressions.tailPoint;
    delete currentLegend.expressions.filter;

    switch (chartType) {
      case "range": {
        const newLegend = createSecondaryLegend(currentLegend);
        legendsCopy.push(newLegend);
        WidgetService.addLegends(this.widgetId, [newLegend]);
        break;
      }
      case "bubble": {
        currentLegend.parameters.chartTypeParameters["min"] = 0;
        currentLegend.parameters.chartTypeParameters["max"] = 100;
        currentLegend.parameters.chartTypeParameters["strokeOpacity"] = 0.5;
        currentLegend.parameters.chartTypeParameters["fillOpacity"] = 0.5;
        break;
      }
      default: {
        if (previousChartType === "range") {
          // remove secondary dataset
          for (let i = 0; i < legendsCopy.length; i++) {
            if (legendsCopy[i].id !== currentLegend.id &&
              legendsCopy[i].parameters.groupId === currentLegend.parameters.groupId) {
              legendsCopy.splice(i, 1);
              break;
            }
          }
          this.updateWidget(legendsCopy);
        }
      }
    }

    this.setState({
      legends: legendsCopy,
      currentLegend: currentLegend
    });


    function createSecondaryLegend(legendCopy) {
      return {
        id: _this.nextLegendId(),
        expressions: {},
        mappings: {},
        parameters: {
          groupId: legendCopy.parameters.groupId,
          legendLabel: "",
          chartType: "range",
          legendColor: legendCopy.parameters.legendColor,
          isActive: legendCopy.parameters.isActive,
          yAxisSide: legendCopy.parameters.yAxisSide,
          chartTypeParameters: {
            fillOpacity: legendCopy.parameters.chartTypeParameters.fillOpacity,
            strokeOpacity: legendCopy.parameters.chartTypeParameters.strokeOpacity
          }
        }
      };
    }
  }

  handleSecondaryLegendChange(propertyName, value) {
    let legendsCopy = this.state.legends.slice();
    let secondaryLegend = this.getSecondaryLegend(legendsCopy);

    if (propertyName === "legendLabel") {
      secondaryLegend.parameters.legendLabel = value;
      this.setState({
        legends: legendsCopy
      });
    } else if (propertyName === "expression") {
      this.handleUpdateExpression(secondaryLegend, value.key, value.expression, value.mappings);
    } else {
      this.updateWidget(legendsCopy);
      this.setState({
        legends: legendsCopy
      });
    }

    if (this.props.isPreviewWidget) {
      this.createOrUpdateDatasetWidget(legendsCopy);
    }
  }

  addLegend(payload, unshift) {
    const legend = this.getDefaultLegend(payload);
    let legendsCopy = this.deepCopy(this.state.legends);
    if (unshift) {
      legendsCopy.unshift(legend);
    } else {
      legendsCopy.push(legend);
    }

    if (this.widgetType === WidgetType.TECHNICAL_ANALYSIS_CHART) {
      if (!legendsCopy.find(l => l.parameters.legendLabel === 'SMA') && !this.TACLegendAdded) {
        legend.id = 'TAC';
        legend.parameters.groupId = 'TAC';
        this.TACLegendAdded = true;
        this.addAutoGeneratedLegendsForTAChart(legendsCopy);
      }
    }

    this.updateWidget(legendsCopy);
    this.setState({
      legends: legendsCopy,
      currentLegend: legend
    });


    if (this.props.isPreviewWidget) {
      this.createOrUpdateDatasetWidget(legendsCopy);
    }
  }

  // add extra legends for TA chart
  addAutoGeneratedLegendsForTAChart(legendsCopy) {
    const newLegendLabels = ["SMA", "RSI", "MACD"];
    newLegendLabels.forEach(label => {
      const legend = {
        id: label,
        expressions: {},
        mappings: {},
        parameters: {
          groupId: label,
          legendLabel: label,
          legendColor: this.getUnUsedLegendColor(legendsCopy),
          chartTypeParameters: {
            fillOpacity: 1,
            strokeOpacity: 1
          },
          isActive: true
        }
      };
      legendsCopy.push(legend);
    });
  }

  copyLegend() {
    let newLegendId = this.nextLegendId();
    let legendCopy = JSON.parse(JSON.stringify(this.state.currentLegend));
    let secondaryLegend = this.getSecondaryLegend();
    let legendsCopy = this.state.legends.slice();

    legendCopy.id = newLegendId;
    legendCopy.parameters.legendLabel = legendCopy.parameters.legendLabel.length > 0 ?
      legendCopy.parameters.legendLabel + "-copy" : "";
    legendCopy.parameters.groupId = newLegendId;
    legendsCopy.push(legendCopy);

    if (secondaryLegend) {
      let secondaryLegendCopy = JSON.parse(JSON.stringify(secondaryLegend));
      secondaryLegendCopy.id = newLegendId + 1;
      secondaryLegendCopy.parameters.legendLabel = secondaryLegendCopy.parameters.legendLabel.length > 0 ?
        secondaryLegendCopy.parameters.legendLabel + "-copy" : "";
      secondaryLegendCopy.parameters.groupId = newLegendId;
      legendsCopy.push(secondaryLegendCopy);
    }

    this.setState({
      legends: legendsCopy,
      currentLegend: legendCopy
    });
    this.updateWidget(legendsCopy);

    if (this.props.isPreviewWidget) {
      this.createOrUpdateDatasetWidget(legendsCopy);
    }
  }

  nextLegendId() {
    let max = 0;
    for (let i = 0; i < this.state.legends.length; i++) {
      let id = this.state.legends[i].id;
      if (typeof id === "number" && id > max) {
        max = id;
      }
    }
    return max + 1;
  }

  handleLegendChange(propertyName, value, isChartTypeParameters = false) {
    let currentLegend = this.state.currentLegend;
    let legendsCopy = this.state.legends.slice();

    switch (propertyName) {
      case "chartType": {
        this.handleChartTypeChange(value);
        break;
      }
      case "columns":
      case "yAxisSide": {
        let secondaryLegend = this.getSecondaryLegend();
        currentLegend.parameters[propertyName] = value;
        if (secondaryLegend) {
          secondaryLegend.parameters[propertyName] = value;
        }
        WidgetService.updateWidgetLegends(this.widgetId, legendsCopy);
        this.setState({
          currentLegend: currentLegend
        });
        this.updateWidget(legendsCopy);
        break;
      }
      case "expression": {
        this.handleUpdateExpression(currentLegend, value.key, value.expression, value.mappings);
        break;
      }
      default: {
        let secondaryLegend = this.getSecondaryLegend();
        if (isChartTypeParameters) {
          currentLegend.parameters.chartTypeParameters[propertyName] = value;
          if (secondaryLegend) {
            secondaryLegend.parameters.chartTypeParameters[propertyName] = value;
          }
          // TODO: (future improvement) we might use two different opacity for specific chart types
          if (propertyName == "fillOpacity" || propertyName == "strokeOpacity") {
            currentLegend.parameters.chartTypeParameters["fillOpacity"] = value;
            currentLegend.parameters.chartTypeParameters["strokeOpacity"] = value;
          }
        } else {
          currentLegend.parameters[propertyName] = value;
          if (secondaryLegend && propertyName !== "legendLabel") {
            secondaryLegend.parameters[propertyName] = value;
          }
        }

        WidgetService.updateWidgetLegends(this.widgetId, legendsCopy);
        this.setState({
          legends: legendsCopy,
          currentLegend: currentLegend
        });
      }
    }

    // notify the legend changes to tooltip component
    this.publish(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, {widgetId: this.widgetId});

    if (this.props.isPreviewWidget) {
      this.createOrUpdateDatasetWidget(legendsCopy);
    }
  }

  openSideNav(sidenav) {
    if (sidenav) {
      this.refs[sidenav].showSideNav();
    } else {
      this.refs.sideNav.showSideNav();
    }
  }

  indexValue(value) {
    this.setState({
      currentLegend: this.state.currentLegend,
      legends: this.state.legends,
      indexValue: value
    });
  }


  onDatasetDrag(data) {
    this.state.data = data;
    this.detailDataset(data);
  }


  detailDataset(data) {
    let tempState;

    let tabControl = {
      tabSelect: 2,
      tabDoNotDisplay: 3
    };

    DatasetService.GetDatasetByIdWithUsersCreated(data.dataset.persistenceId).then(dataset => {
      DatasetService.checkUserDatasetSubscription(data.dataset.persistenceId).then(subscriptions => {

        this.setState({
          datasetDetail: {
            dataset: dataset,
            subscriptions: subscriptions,
          }
        });
        let props = {
          dataset: dataset,
          subscriptions: subscriptions,
          onModalClose: this.handleDetailClosed,
          tabControl: tabControl,
          callback: this.response,
          response: true

        };
        ReactDOM.render(React.createElement(DatasetDetail, props), this.refs.test);
      });
    });
  }

  handleDetailClosed() {
    $(".modal-overlay").remove();
    ReactDOM.unmountComponentAtNode(this.refs.test);
  }


  response(data) {
    this.addLegend(this.state.data);
    this.handleDetailClosed();
  }

  handleMetaDataChange(field, value) {
    const state = {};
    state[field] = value;
    this.setState(state);
    WidgetService.updateWidgetMetaData(this.widgetId, state);
    this.updateWidget(this.copyLegends());
  }

  copyLegends() {
    return JSON.parse(JSON.stringify(this.state.legends));
  }


  // create or update dataset widget in databank
  createOrUpdateDatasetWidget() {
    const widget = WidgetService.getWidget(this.widgetId);
    const widgetState = JSON.stringify({
      widgetType: this.widgetType,
      legends: widget ? widget.legends : [],
      metaData: widget ? widget.metaData : {}
    });

    if (this.hasDefaultWidget || !this.datasetWidget || this.datasetWidget.isDefaultWidget) {
      DatasetService.createDatasetWidget(this.props.dataset.datasetId, widgetState, function () {
      });
    } else {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        var newWidget = JSON.parse(JSON.stringify(this.datasetWidget));
        newWidget.widgetState = widgetState;
        DatasetService.updateUserDatasetWidget(newWidget, function (res) {
        });
      }, 300);
    }
  }

  // copy dataset widget in databank to the selected dashboard
  copyWidgetToDashboard(targetDashboardId, title) {
    let componentId = UniqueIdGenerator.id();
    let components = {};
    components[componentId] = {
      controller: {
        id: componentId,
        widgetId: this.widgetId,
        type: this.datasetWidget.widgetState.widgetType
      }
    };

    DashboardService.addOrUpdateWidgetToDashboard(targetDashboardId, {
      id: UniqueIdGenerator.id(),
      title,
      legends: this.state.legends,
      type: this.widgetType,
      components
    }).then(() => {
      this.refs["copyDashboardSidenav"].hideSideNav();
    });
  }

  handleConfigChange(option, value, needUpdateWidget = true) {
    const configsCopy = Object.assign({}, this.state.timeSeriesConfigs);
    configsCopy[option] = value;
    this.setState({
      timeSeriesConfigs: configsCopy
    }, () => {
      // Don't need to update widget on resolution option changes
      if(needUpdateWidget) {
        this.updateWidget(this.state.legends);
      }
    });
  }

  renderConfigs() {
    switch (this.widgetType) {
      case WidgetType.TIME_SERIES_VERTICAL:
      case WidgetType.TIME_SERIES: {
        // return (
        //   <div className={styles.autoAdjust}>
        //     <CheckBox value={this.state.splitLeftRight} text="Separate Left Right Axis Data"
        //               onChange={this.handleSplitLeftRightChange}/>
        //     <CheckBox value={this.state.centerZeroLine} text="Center Zero Line"
        //               onChange={this.handleCenterZeroLineChange}/>
        //     <CheckBox value={this.state.autoAdjustWindowSize} text="Display All Data"
        //               onChange={this.handleAutoAdjustChange}/>
        //   </div>);
        return <TimeSeriesCongifs timeSeriesConfigs={this.state.timeSeriesConfigs} onConfigChange={this.handleConfigChange} />;
      }
      case WidgetType.PIE_CHART: {
        return (
          <div className={styles.autoAdjust}>
            <CheckBox value={this.state.showLegends} text="Show Legends"
                      onChange={value => this.handleMetaDataChange("showLegends", value)}/>
          </div>);
      }

    }

  }


  render() {
    let legendConfig = null;
    let legends = null;
    let sideNav = null;
    let copydashboardSideNav = <SideNav ref="copyDashboardSidenav" opacity={0}>
      <CopyToDashboard onCopy={this.copyWidgetToDashboard}/>
    </SideNav>;
    let copyToDashboardBtn = <i className={["icon-action-redo", styles.sidenavToggle].join(" ")}
                                onClick={() => this.openSideNav("copyDashboardSidenav")}/>;
    let toggleSideNavBtn = <i className={["icon-menu", styles.sidenavToggle].join(" ")}
                              onClick={() => this.openSideNav("dataProfileSideNav")}/>;
    let configStyle = {};
    if (this.props.isStudioWidget) {
      configStyle = {
        bottom: "30px",
        maxHeight: "80%",
        overflowY: "auto"
      }
    }
    if (this.state.currentLegend !== null) {
      switch (this.widgetType) {
        case WidgetType.TIME_SERIES_VERTICAL:
        case WidgetType.TIME_SERIES: {
          legendConfig = <TimeSeriesConfig
            widgetId={this.widgetId}
            isStudioWidget={this.props.isStudioWidget}
            configStyle={configStyle}
            legend={this.state.currentLegend}
            secondarylegend={this.getSecondaryLegend()}
            onLegendChange={this.handleLegendChange}
            closeLegendConfig={this.closeLegendConfig}
            copyLegend={this.copyLegend}
            onSecondaryLegendChange={this.handleSecondaryLegendChange}
            callback={this.onDatasetDrag}
            subscribedDataset={this.state.subscribedDataset}/>;
          break;
        }
        case WidgetType.RANK_WIDGET:
        case WidgetType.BULLET_VERTICAL:
        case WidgetType.MAP:
        case WidgetType.PIE_CHART: {
          legendConfig = <PieConfig
            widgetId={this.widgetId}
            configStyle={configStyle}
            legend={this.state.currentLegend}
            onLegendChange={this.handleLegendChange}
            copyLegend={this.copyLegend}
            closeLegendConfig={this.closeLegendConfig}
            callback={this.onDatasetDrag}
            subscribedDataset={this.state.subscribedDataset}/>;
          break;
        }
        case WidgetType.TEXTUAL: {
          legendConfig = <TextualConfig
            widgetId={this.widgetId}
            configStyle={configStyle}
            legend={this.state.currentLegend}
            onLegendChange={this.handleLegendChange}
            closeLegendConfig={this.closeLegendConfig}
            callback={this.onDatasetDrag}
            subscribedDataset={this.state.subscribedDataset}/>;
          break;
        }
        case WidgetType.GAUGE: {
          legendConfig = <GaugeConfig
            widgetId={this.widgetId}
            legend={this.state.currentLegend}
            onLegendChange={this.handleLegendChange}
            closeLegendConfig={this.closeLegendConfig}
            callback={this.onDatasetDrag}
            subscribedDataset={this.state.subscribedDataset}/>;
          break;
        }
        case WidgetType.TREE_MAP: {
          legendConfig = <TreeMapConfig
            widgetId={this.widgetId}
            configStyle={configStyle}
            legend={this.state.currentLegend}
            onLegendChange={this.handleLegendChange}
            closeLegendConfig={this.closeLegendConfig}
            callback={this.onDatasetDrag}
            subscribedDataset={this.state.subscribedDataset}/>;
          break;
        }
        case WidgetType.TRADING_VIEW:
        case WidgetType.TECHNICAL_ANALYSIS_CHART: {
          legendConfig = <TechnicalAnalysisConfig
            widgetId={this.widgetId}
            configStyle={configStyle}
            legend={this.state.currentLegend}
            onLegendChange={this.handleLegendChange}
            closeLegendConfig={this.closeLegendConfig}
            callback={this.onDatasetDrag}
            subscribedDataset={this.state.subscribedDataset}/>;
          break;
        }
        case WidgetType.TABLE: {
          break;
        }
      }
    }

    let selectedLegendId = this.state.currentLegend ? this.state.currentLegend.id : "";
    if (this.widgetType !== WidgetType.GAUGE &&
      this.widgetType !== WidgetType.TEXTUAL &&
      this.widgetType !== WidgetType.TABLE) {
      legends = <Legends legends={this.state.legends}
                         isStudioWidget={this.props.isStudioWidget}
                         currentLegendId={selectedLegendId}
                         handleDrop={this.addLegend}
                         widgetType={this.widgetType}
                         removeCurrentLegend={this.handleRemoveCurrentLegend}
                         changeCurrentLegend={this.handleChangeCurrentLegend}
                         indexValue={this.state.indexValue}
                         response={this.indexValue}
                         callback={this.onDatasetDrag}/>;
    }

    if (this.widgetType === WidgetType.TABLE) {
      legends =
        <TableLegend handleDrop={this.addLegend} legends={this.state.legends} openSideNav={this.openSideNav}
                     indexValue={this.state.indexValue} callback={this.onDatasetDrag}/>;
      toggleSideNavBtn = null;
      copyToDashboardBtn = null;
      if (this.state.currentLegend) {
        sideNav = <SideNav ref="dataProfileSideNav">
          <TableFieldList fields={this.state.currentLegend.parameters.columns}
                          onLegendChange={this.handleLegendChange}/>
        </SideNav>;
      }
    } else {
      // sideNav = <SideNav ref="dataProfileSideNav" opacity={0}>
      //   <FieldList dataset={this.props.dataset} fields={this.props.fields}/>
      // </SideNav>;
    }


    if (this.props.isStudioWidget) {
      return (
        <div className={styles.container} ref="container">
          <div style={{display: "flex", flex: 1, position: "relative", flexDirection: "column"}}>
            <div className="widget-container"
                 style={{flex: 1, maxHeight: 'calc(100% - 150px)'}}
                 id={this.widgetId} ref="chartContainer"/>

            <ReactCSSTransitionGroup transitionName="example"
                                     transitionEnterTimeout={200}
                                     transitionLeaveTimeout={200}
                                     component="div" className="legend-config-wrapper">
              {legendConfig}
            </ReactCSSTransitionGroup>
            {legends}
            <div id="tooltips-container">
            </div>
          </div>
        </div>
      );
    } else if (this.props.isPreviewWidget) {
      sideNav = <SideNav ref="dataProfileSideNav" opacity={0}>
        <FieldList dataset={this.props.dataset} fields={this.props.fields}/>
      </SideNav>;
      return (
        <div className={styles.container} style={{opacity: 1, padding: "0 8px"}}>
          <div className={styles.addWidget}>
            <div className={this.props.isPreviewWidget ? styles.contentPreview : styles.content}>
              <div style={{display: "flex", flex: 1, position: "relative"}}>
                <div style={{flex: 1}} id={this.widgetId} ref="chartContainer"></div>
                {copyToDashboardBtn}
                {toggleSideNavBtn}
                <ReactCSSTransitionGroup transitionName="example"
                                         transitionEnterTimeout={200}
                                         transitionLeaveTimeout={200}
                                         component="div" className="legend-config-wrapper">
                  <div>
                    {legendConfig}
                  </div>
                </ReactCSSTransitionGroup>
              </div>
              {legends}
            </div>
          </div>
          {sideNav}
          {copydashboardSideNav}
        </div>
      );
    } else {
      return (
        <div className={styles.container} ref="container">
          <div ref="test"/>
          <div className={styles.addWidget}>
            <AddWidgetSearch widgetType={this.widgetType} index={this.state.indexValue} indexValue={this.indexValue}/>
            <div className={styles.content}>
              <Title title={this.state.title} handleTitleChange={this.handleTitleChange}/>
              {this.renderConfigs()}
              <div style={{display: "flex", flex: 1, position: "relative", maxHeight:  this.widgetType === WidgetType.TIME_SERIES_VERTICAL ? 'calc(100% - 240px)' : ''}}>
                <div className="widget-container"
                     style={{flex: 1, maxHeight: this.widgetType === WidgetType.TIME_SERIES_VERTICAL ? 'calc(100% - 50px)' : ''}}
                     id={this.widgetId} ref="chartContainer"/>

                <ReactCSSTransitionGroup transitionName="example"
                                         transitionEnterTimeout={200}
                                         transitionLeaveTimeout={200}
                                         component="div" className="legend-config-wrapper">
                  {legendConfig}
                </ReactCSSTransitionGroup>
              </div>
              {legends}
            </div>
          </div>
          {sideNav}
          <div id="tooltips-container">
          </div>
          <div className={styles.actions}>
            <button
              className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect waves-red"].join(' ')}
              onClick={this.onCancelClick}>Discard
            </button>
            <button className={[styles.actionButton, "btn waves-effect"].join(' ')}
                    onClick={this.onConfirmClick}>Update
            </button>
          </div>
        </div>
      );
    }
  }
}

AddWidget.contextTypes = {
  router: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/addWidget.jsx